"use strict";function uploadAttachment$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.uploadAttachment$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.uploadAttachment";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"3.0.0"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.7.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.7.0"},_a)),exports.uploadAttachment$=uploadAttachment$,exports.default=uploadAttachment$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/uploadAttachment.js
// module id = 1032
// module chunks = 106